import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Lock, Eye, EyeOff } from 'lucide-react';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('Le mot de passe doit contenir au moins 6 caractères.'); return; }
    if (password !== confirm) { setError('Les deux mots de passe ne correspondent pas.'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Une erreur est survenue');
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <h1 className="text-2xl text-gray-800 mb-2" style={{ fontFamily: "'Manrope', sans-serif" }}>
          Nouveau mot de passe
        </h1>
        {done ? (
          <div className="mt-6 bg-[#FFFDF6] border border-[#F3EEE5] rounded-[20px] p-6 text-center" data-testid="reset-success">
            <p className="text-sm text-gray-600 leading-relaxed">
              Mot de passe mis à jour.
              <br />Tu vas être redirigée vers la connexion…
            </p>
          </div>
        ) : !token ? (
          <div className="mt-6 bg-[#FFFDF6] border border-[#F3EEE5] rounded-[20px] p-6 text-center" data-testid="reset-no-token">
            <p className="text-sm text-gray-600">Lien invalide.</p>
            <Link to="/mot-de-passe-oublie" className="text-[#F79AAE] text-sm block mt-3">Refaire une demande</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5 mt-6">
            {[{ v: password, set: setPassword, ph: 'Nouveau mot de passe', tid: 'reset-password-input' },
              { v: confirm, set: setConfirm, ph: 'Confirme le mot de passe', tid: 'reset-confirm-input' }].map((f) => (
              <div key={f.tid} className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-300" size={18} />
                <input
                  type={show ? 'text' : 'password'}
                  value={f.v}
                  onChange={(e) => f.set(e.target.value)}
                  className="w-full pl-12 pr-12 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-[#F79AAE] transition-colors text-gray-700"
                  placeholder={f.ph}
                  required
                  data-testid={f.tid}
                />
                <button type="button" onClick={() => setShow(!show)} className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-300">
                  {show ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            ))}
            {error && <p className="text-sm text-red-400 text-center" data-testid="reset-error">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-[#F79AAE] text-white rounded-xl text-sm hover:bg-[#e8868d] transition-colors disabled:opacity-50"
              data-testid="reset-submit-btn"
            >
              {loading ? 'Mise à jour…' : 'Valider'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
